// Saves text content to a file via the browser's own download mechanism: a
// Blob, an object URL, and a synthetic anchor click. Kept in its own module —
// rather than inlined at each call site — so a test can spy on `saveFile`
// itself instead of asserting on DOM side effects (anchor clicks, object URL
// lifetimes) that happy-dom doesn't fully implement.

export function saveFile(filename: string, content: string, mimeType = "text/plain") {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    try {
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = filename;
        anchor.click();
    } finally {
        // Deferred rather than synchronous: revoking immediately after
        // .click() can race the browser actually starting the download,
        // losing a key file that (until rotation lands) is unrecoverable.
        setTimeout(() => URL.revokeObjectURL(url), 0);
    }
}
